import React from 'react';

//import { SubHeading } from '../../components';
import { images } from '../../constants';

const Location = () => (
  <div className="app__bg app__wrapper section__padding" id="contact">
    <div className="app__wrapper_info">
      <h1 className="headtext__cormorant" style={{ marginBottom: '3rem' }}>Location</h1>
      <div className="app__wrapper-content">
        <p className="p__opensans">One Golden Palace Lane, Debonair, XA.</p>
        <p className="p__cormorant" style={{ color: '#DCCA87', margin: '2rem 0' }}>For Your Dining Pleasure</p>
        <p className="p__opensans">Platinum members are afforded private dining areas.</p>
        <p className="p__opensans">Diamond members are able to reserve the entire restuarant with 2 weeks notice.</p>
      </div>
      <button type="button" className="custom__button" style={{ marginTop: '1.5rem' }}>Learn More</button>
    </div>

    <div className="app__wrapper_img">
      <img src={images.location} alt="location" />
    </div>
  </div>
);

export default Location;